import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { z } from "zod";
import { projectWorkstreamSchema } from "tekkr-common/dist/model/project/project";

type ProjectWorkstream = z.infer<typeof projectWorkstreamSchema>;
type WsPreviewData = Pick<ProjectWorkstream, "name" | "description">;

interface Input {
    ws?: WsPreviewData;
    projectId?: string;
}

interface Options {
    onSuccess?: () => void;
}

export function useKickOffProjectMutation(projectId?: string, options?: Options) {
    return useMutation({
        mutationFn: async (input: Input = {}) => {
            const id = input.projectId ?? projectId;
            if (!id) {
                throw new Error("Project ID is required");
            }

            const res = await apiClient.kickOffProject({
                params: { id },
                body: {
                    alignmentWorkstream: input.ws,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to kick off project");
            }
        },
        onSuccess: options?.onSuccess,
    });
}
